import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import BetPill from 'Components/Pills/BetPill';
import { classnames } from 'Utils/classnames';
import { renderScoreStatus } from 'Utils/scoreDisplayHelper';
import BetSlipOddsWsUpdate from './betSlipOddsWsUpdate';
import SportTypeIcon from 'Components/SportTypeIcon';
import { MULTIPLE_SPORT_TYPES, URL_MAP_BY_TYPE, BETTING_PHASE, EVENT_STREAM_ICONS, HANDBALL } from 'Store/constants/sportTypes';
import History from 'Store/history';
import LocalStorage from 'Utils/localStorage';
import { Badge } from 'Components/Badge';
import { getStreamInfoDetail } from 'Utils/getStreamInfoDetail';
import EnvironmentManager from 'Utils/environmentManager';
import { HALF_TIME } from '../../../store/constants/sportTypes';

class BetSlipRow extends Component {

  constructor (props) {
    super(props);

    this.state = {
      showStreamInfoPopup: false
    };
  }

  static propTypes = {
    data: PropTypes.object,
    isSystem: PropTypes.bool,
    onRemoveClick: PropTypes.func,
    onBankerClick: PropTypes.func,
    toggleBetSlip: PropTypes.func,
    eventScores: PropTypes.object,
    closeInteraction: PropTypes.bool,
    betSlipClose: PropTypes.func,
    topWinEnabled: PropTypes.bool,
  };

  renderFootballTime = score => {
    if (score.type === HALF_TIME) {
      return score.title;
    }

    return score.time;
  };

  renderBottomRow = () => {
    const { eventScores, data, isSystem, topWinEnabled } = this.props;
    const { isLive, bets, eventId, startDate, startTime } = data;

    const renderScore = () => {

      const eventScoreEntry = eventScores?.data?.[eventId];
      const { home = '', away = '' } = eventScoreEntry?.currentScore || {};
      const sportType = eventScoreEntry?.sportType;
      const normalizedSportType = sportType === 'HANDBALL' ? HANDBALL : sportType;

      return isLive && eventScores.data && eventScores.data[eventId] ? (
        <div className="betslip-row__score-container">
          <div className="betslip-row__score">
            { home !== '' && away !== '' ? `${home} - ${away}` : '' }
          </div>
          <div className="betslip-row__minute">
            { /* eslint-disable-next-line no-nested-ternary */ }
            { !MULTIPLE_SPORT_TYPES.FOOTBALL.includes(sportType)
              ? renderScoreStatus(eventScoreEntry?.currentScore, normalizedSportType, eventScoreEntry?.scores)
              : this.renderFootballTime(eventScoreEntry?.currentScore) }
          </div>
        </div>
      ) : ( <div className="betslip-row__date">
        { startDate } <strong>{ startTime }</strong>
      </div>);
    };

    return bets && bets.map((market, index) => {

      const bankerIconName = classnames({
        iconBanko: !market.banker,
        iconBankoActive: market.banker
      });

      const iconData = index === 0 ? <Icon iconName={ bankerIconName } /> : null;
      const zirveOranSwitch = EnvironmentManager.getMessageText({ key: 'zirveoran_switch' }) == 'true';

      return (
        <div key={ index } className="betslip-row betslip-row--bottom">
          <div className="betslip-row__banko" onClick={ () => this.props.onBankerClick(eventId, market.marketId, market.marketOutcomeNo) }>
            { iconData }
          </div>
          <div className="betslip-row__bet-pill">
            <BetPill pillStyle="horizontal"
              isSystem={ isSystem }
              isSelected={ true }
              odd={ market.odd }
              tWinOdd={ market?.topWinOdds }
              betType={ market.betType }
            />
            { zirveOranSwitch && topWinEnabled && market?.topWinOdds && !isSystem ? <Icon  iconName='svgZirveOran' /> : null }
          </div>
          { bets.length - 1 === index ? renderScore() : null }
        </div>
      );
    });
  };

  navigateToMatchcard = (sporType, eventId, openSlideName) => {
    if (sporType >= 1000) {
      return;
    }
    this.props.betSlipClose();
    LocalStorage.set('betSlipToggler', false);
    LocalStorage.set('betSlipOpened', true);
    if (openSlideName) {
      History.push(`/mac-karti/${URL_MAP_BY_TYPE[sporType]}/${eventId}/oranlar`, { openSlideName });
    } else {
      History.push(`/mac-karti/${URL_MAP_BY_TYPE[sporType]}/${eventId}`);
    }
  };

  render () {
    const {
      name,
      bettingStatus,
      hasLiveStream,
      bets,
      wsBettingStatus,
      sportType,
      eventId,
      channel,
      eventStartDate
    } = this.props.data;

    const { odd, prevOdd, mbs  } = bets[0];

    const mbsIconArea = bettingStatus !== BETTING_PHASE.PREMATCH ? (
      <Badge>
        <i className="bly bly-live"/>
        <span>Canlı</span>
      </Badge>
    ) : null;

    const oddChangedContainerClassName = classnames({
      'betslip-row__container': true,
      'betslip-row__container--odd-change': prevOdd
    });

    const renderStreamInfo = () => {
      if (
        !hasLiveStream
        || !EVENT_STREAM_ICONS[hasLiveStream]
        || (!channel && getStreamInfoDetail(hasLiveStream).other)
      ) {
        return null;
      }
      let popupText = '';
      if (getStreamInfoDetail(hasLiveStream).bilyoner || getStreamInfoDetail(hasLiveStream).both) {
        popupText = `${EnvironmentManager.getMessageText({ key: 'bilyoner_tv_live_message' })}`;
        if (channel && getStreamInfoDetail(hasLiveStream).both) {
          popupText = `${popupText} <hr> ${EnvironmentManager.getMessageText({ key: 'bilyoner_tv_statik_message' })} &nbsp;<b>${channel}</b>`;
        }
      } else if (channel && getStreamInfoDetail(hasLiveStream).other) {
        popupText = `${EnvironmentManager.getMessageText({ key: 'bilyoner_tv_statik_message' })} <b>${channel}</b>`;
      }
      const now = new Date();
      return hasLiveStream && EVENT_STREAM_ICONS[hasLiveStream] ? (
        <div className="betslip-row__teams--stream-info--wrapper">
          <Icon
            className="betslip-row__tv-icon"
            iconName={ EVENT_STREAM_ICONS[hasLiveStream] }
            onClick={ e => {
              e.stopPropagation();
              if (now < new Date(eventStartDate)) {
                this.setState({
                  showStreamInfoPopup: true
                });
                setTimeout(() => {
                  this.setState({
                    showStreamInfoPopup: false
                  });
                }, 2000);
              } else {
                this.navigateToMatchcard(sportType, eventId, 'stream');
              }
            }
            }
          />
          { this.state.showStreamInfoPopup
            && <div
              className="betslip-row__teams--stream-info"
              dangerouslySetInnerHTML={ { __html: popupText } }
            /> }
        </div>
      ) : null;
    };

    const isSuspendedStatus = wsBettingStatus === 'Bahis beklemeye alınmıştır.';

    return (
      <div className={ oddChangedContainerClassName }>

        { prevOdd && <BetSlipOddsWsUpdate prevOdd={ prevOdd } odd={ odd } /> }

        { wsBettingStatus && (
          <div className={ classnames({
            'betslip-row__block-message': true,
            'betslip-row__suspended-block-message': isSuspendedStatus,
            animated: true,
            fadeIn: true
          }) }>
            <span>
              { wsBettingStatus }
            </span>
          </div>
        ) }

        <div className="betslip-row">
          <SportTypeIcon type={ sportType }/>

          <div className="betslip-row__teams" onClick={ () => this.navigateToMatchcard(sportType, eventId) }>
            <span>{ name }</span>
            { renderStreamInfo() }
            { mbsIconArea }
          </div>

          <div className="betslip-row__delete">
            <Icon className="betslip-row__icon-delete"  iconName="svgTrashGrey" onClick={ () => this.props.onRemoveClick(bets[0].id) } />
          </div>
        </div>

        <div className="betslip-row">
          <Icon iconName={  `iconMbs${mbs}Horizontal` } />
          <div className="betslip-row__description">
            { bets && bets[0].marketName }
          </div>
          <div />
        </div>

        { this.renderBottomRow() }
      </div>
    );
  }
}

export default BetSlipRow;
